import { render } from "./Familias.vue?vue&type=template&id=689167a0&ts=true"
import script from "./Familias.vue?vue&type=script&lang=ts"
export * from "./Familias.vue?vue&type=script&lang=ts"

import "./Familias.vue?vue&type=style&index=0&id=689167a0&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__